// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__5Sr-T","range":"MonthRangeSwitch_range__34xtl","disabled":"MonthRangeSwitch_disabled__2G75v"};